var _path, _path2, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAlert = function SvgAlert(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 1c.8 0 1.423.696 1.334 1.49l-.779 7.013A.559.559 0 0 1 8 10",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 1c.8 0 1.423.696 1.334 1.49l-.779 7.013a.559.559 0 0 1-1.11 0l-.78-7.012A1.343 1.343 0 0 1 8 1Z",
    fill: "currentColor"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 13.5,
    r: 1.5,
    fill: "currentColor"
  })));
};
export { SvgAlert as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciICB2aWV3Qm94PSIwIDAgMTYgMTYiIGZpbGw9Im5vbmUiPgogICAgPHBhdGggZD0iTTggMUM4LjgwMDE4IDEgOS40MjI3MiAxLjY5NTU0IDkuMzM0MzUgMi40OTA4M0w4LjU1NTIyIDkuNTAzMDZDOC41MjM3OCA5Ljc4NTk3IDguMjg0NjUgMTAgOCAxMCIgZmlsbD0iY3VycmVudENvbG9yIi8+CiAgICA8cGF0aCBkPSJNOCAxQzguODAwMTggMSA5LjQyMjcyIDEuNjk1NTQgOS4zMzQzNSAyLjQ5MDgzTDguNTU1MjIgOS41MDMwNkM4LjUyMzc4IDkuNzg1OTcgOC4yODQ2NSAxMCA4IDEwQzcuNzE1MzUgMTAgNy40NzYyMiA5Ljc4NTk3IDcuNDQ0NzggOS41MDMwNkw2LjY2NTY1IDIuNDkwODNDNi41NzcyOCAxLjY5NTU0IDcuMTk5ODIgMSA4IDFaIiBmaWxsPSJjdXJyZW50Q29sb3IiLz4KICAgIDxjaXJjbGUgY3g9IjgiIGN5PSIxMy40OTk5IiByPSIxLjUiIGZpbGw9ImN1cnJlbnRDb2xvciIvPgo8L3N2Zz4=";